import { render } from "./Blob.vue?vue&type=template&id=7d4c9528"
import script from "./Blob.vue?vue&type=script&lang=js"
export * from "./Blob.vue?vue&type=script&lang=js"
script.render = render

export default script